import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { MaskedLines } from "@/components/motion/MaskedLines";
import { Reveal } from "@/components/motion/Reveal";

export const Caregivers = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section ref={ref} className="relative bg-navy lg:min-h-[92vh]" data-testid="caregivers-section">
      <div className="relative h-[58vh] overflow-hidden lg:absolute lg:inset-0 lg:h-full">
        <motion.img style={{ y, scale: 1.16 }} src="/images/scene-care.jpg" alt="Una caregiver si prende cura con affetto di una signora anziana" loading="lazy" className="h-full w-full origin-[70%_0%] object-cover object-[72%_0%]" />
        <div className="absolute inset-0 hidden bg-gradient-to-r from-navy via-navy/75 to-transparent lg:block" />
      </div>
      <div className="container-pf relative py-20 lg:flex lg:min-h-[92vh] lg:items-center lg:py-0">
        <div className="max-w-xl text-ivory">
          <p className="text-[13px] uppercase tracking-[0.28em] text-copper-light">Per chi si prende cura</p>
          <h2 className="mt-5 font-display text-4xl font-medium leading-[1.04] sm:text-5xl lg:text-6xl">
            <MaskedLines lines={["Prendersi cura", "di chi ci ha", <em className="italic text-copper-light">cresciuti.</em>]} />
          </h2>
          <Reveal delay={0.2}>
            <p className="mt-8 text-lg leading-relaxed text-ivory/85">
              Figli, nipoti, assistenti familiari, infermieri: Perfero accompagna anche le mani di chi assiste. Una linea completa per l'igiene quotidiana, dalla detersione delicata all'incontinenza, con prodotti semplici da usare e piacevoli da ricevere.
            </p>
            <Link to="/collezione" data-testid="caregivers-cta" className="mt-10 inline-flex h-14 items-center gap-3 rounded-full bg-ivory px-8 text-base font-medium text-navy transition-colors duration-300 hover:bg-copper-light">
              Scopri la linea completa <ArrowRight className="h-5 w-5" />
            </Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
